class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector('a')
    removeFilterNode.addEventListener('click', (e) => {
      e.preventDefault();
      const filtersForm = this.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      let searchParams = new URL(removeFilterNode.href).searchParams.toString();

      // Check if this is removing the last filter (excluding Universal)
      const hasFilters = searchParams &&
      (
        searchParams.includes('filter.v.option.device') ||
        searchParams.match(/filter\.v\.m\.custom\.variant_custom_filter=(?!Universal)/g) ||
        searchParams.match(/filter\.v\.m\.custom\.variant_custom_filter_list=(?!Universal)/g) ||
        searchParams.includes('filter.v.m.custom.variant_color')
      );

      // If no filters remain, clear the cached filters and remove Universal
      if (!hasFilters) {
        // Remove Universal filter from URL
        searchParams = searchParams.replace(/&?filter\.v\.m\.custom\.variant_custom_filter=Universal/g, '');
        searchParams = searchParams.replace(/&?filter\.v\.m\.custom\.variant_custom_filter_list=Universal/g, '');
        searchParams = searchParams.replace(/^&/, '');

        // Access the global cached filter arrays from storefont-filters.js
        if (typeof cachedDeviceFilters !== 'undefined') {
          while (cachedDeviceFilters.length > 0) {
            cachedDeviceFilters.pop();
          }
        }
        if (typeof cachedColorFilters !== 'undefined') {
          while (cachedColorFilters.length > 0) {
            cachedColorFilters.pop();
          }
        }
      }

      filtersForm.renderPage(searchParams);
    });
  }
}

customElements.define('facet-remove', FacetRemove);
